// extracted by mini-css-extract-plugin
module.exports = {"image":"CategoryPoint_image__3hzED"};